import { useEmptyStateContext } from '../../StateManagment/EmptyStateContext'
import DashboardCardEmptyState from './DashboardCardEmptyState'

// AI-CONTEXT: See docs/features/dashboard-empty-states.md
//
// "No data yet" state for the shared analytics chart layer (Visualisations/*).
// The visual (bloom + headline + subtext) renders everywhere the charts are
// used; the CTA button only renders where EmptyStateContext.showCta is true
// (dashboard + Analyse page). Public LiveReports and print views render the
// charts without a provider, so they get the visual but no CTA.

/**
 * Empty state for a chart leaf. Reads copy/CTA context from EmptyStateContext.
 */
const AnalyticsEmptyState = () => {
    const { type, showCta, headline, subtext } = useEmptyStateContext()
    /* headline/subtext are set when a period is active: the generic copy promises
       data will appear "zodra ze beschikbaar zijn", which is untrue when the data
       exists just outside the window. Inbox #223.
       cta={null} hides the button; cta={undefined} lets the per-type default show. */
    return (
        <DashboardCardEmptyState
            type={type}
            headline={headline}
            subtext={subtext}
            cta={showCta ? undefined : null}
        />
    )
}

export default AnalyticsEmptyState
